import { defineStore } from 'pinia'
import { Platform } from 'quasar'
import { usePersistedStore } from 'src/stores/persisted'
import { useCommonStore } from 'src/stores/common'

export const useLocationDetailStore = defineStore('locationDetail', {
  state: () => ({
    locations: {},
    location: null,
    loading: false,
    milesOptions: [
      {
        label: '5 Miles',
        val: '5',
      },
      {
        label: '10 Miles',
        val: '10',
      },
      {
        label: '15 Miles',
        val: '15',
      },
      {
        label: '20 Miles',
        val: '20',
      },
      {
        label: '25 Miles',
        val: '25',
      },
      {
        label: '25+ Miles',
        val: '-1',
      },
    ],
  }),
  getters: {
    getLocationById: (state) => (locationId) => state.locations[locationId],
    allowPayAtStoreForFulfillment(state) {
      return (fulfillmentCode) => {
        let allowPayAtStore = false
        const persistedStore = usePersistedStore()
        const currentLocationId = persistedStore.currentLocationId
        const location = this.getLocationById(currentLocationId)
        location?.fulFillments?.every(function (fulfillment) {
          if (fulfillment.codeName == fulfillmentCode) {
            allowPayAtStore = fulfillment.allowPayAtStore
            return false
          }
          return true
        })
        return allowPayAtStore
      }
    },
    payAtStoreAllowForUser() {
      return (fulfillmentCode) => {
        const persistedStore = usePersistedStore()
        let payAtStoreAllowForUser = 4
        const currentLocationId = persistedStore.currentLocationId
        const location = this.getLocationById(currentLocationId)
        location?.fulFillments?.every(function (fulfillment) {
          if (fulfillment.codeName == fulfillmentCode) {
            payAtStoreAllowForUser = fulfillment.payAtStoreUserType
            return false
          }
          return true
        })

        return payAtStoreAllowForUser
      }
    },
    isScanningDLQRCodeRequired() {
      const persistedStore = usePersistedStore()
      const commonStore = useCommonStore()

      let selectedFulfillmentCodeName =
        persistedStore.selectedFulfillmentCodeName || ''
      const fulFillmentLocations = commonStore.fulFillmentLocations || {}
      let targetFulfillment =
        fulFillmentLocations[selectedFulfillmentCodeName] || {}
      if (targetFulfillment?.isScanningDLQRCodeRequired)
        return targetFulfillment.isScanningDLQRCodeRequired
      else return false
    },
  },
  actions: {
    async fetchLocation({ locationId, isLocationDetailPage = false }) {
      const commonStore = useCommonStore()

      const setHeaderTitle = (location) => {
        if (Platform?.is?.mobile)
          commonStore.setHeaderTitle({ title: location.name })
      }

      if (this.location && locationId == this.location.locationId) {
        isLocationDetailPage && setHeaderTitle(this.location)
        return this.location
      }

      var location = this.getLocationById(locationId)
      if (location) {
        if (isLocationDetailPage) this.location = location
        return location
      }

      if (isLocationDetailPage) this.loading = true

      try {
        let { data } = await this.$axiosInstance.get(
          `/Location/Detail/${locationId}`,
          {
            params: {
              IncludeConfiguration: true,
            },
          }
        )

        if (data.data) isLocationDetailPage && setHeaderTitle(data.data)

        if (isLocationDetailPage) this.location = data.data
        this.locations[data.data.locationId] = data.data
        this.loading = false

        return data.data
      } catch (error) {}
    },
    async getNearBYLocation(params) {
      try {
        let { data } = await this.$axiosInstance.get('/location', { params })
        return data
      } catch (error) {
        return false
      }
    },
  },
})
